// src/schema/patientSchema.js

// 単一ソース: ここを書き換えるだけで全画面に反映
export const ENUMS = {
  gender_type: ['男性', '女性', 'その他'],
  ms_type: ['RIS', 'CIS', 'RRMS', 'SPMS', 'PPMS', 'その他'],
  recurrences_times: ['なし', '1 回', '2-4 times', 'Over 5 times'],
  pira_presence: ['なし', 'あり'],
  aqp4_test: ['陽性（CBA）', '陽性（ELISA）', '陰性（CBA）', '陰性（ELISA）', '未検査'],
  mog_test: ['陽性（CBA）', '陽性（その他）', '陰性（CBA）', '陰性（その他）', '未検査'],
  cerebrospinal_fluid_test: ['なし', 'あり'],
  ocb_result_type: ['陽性', '陰性'],
  fluid_test_company: ['LSI', 'SRL', 'その他'],
  onset_mode: ['attack', '障害進行', '無症状（RIS）'], // 追加要望
};

// ★jpはDB定義書の表記に準拠（UI表示ラベル）
export const FIELDS = [
  // ---- 個人情報 ----
  // { key: 'doctor_id',     jp: '主治医ID',                 type: 'string',   required: true },
  { key: 'research_id',     jp: '研究ID',                 type: 'string',   required: true },
  { key: 'consultation_id', jp: '患者名',               type: 'string' },
  { key: 'patient_pw',      jp: '患者パスワード',         type: 'password', required: true },
  { key: 'date_of_birth',   jp: '生年月日',               type: 'date',     required: true },
  { key: 'gender_type',     jp: '性別',                   type: 'enum',     enum: ENUMS.gender_type, required: true },
  { key: 'ms_type',         jp: 'MSのタイプ',             type: 'enum',     enum: ENUMS.ms_type, required: true },
  { key: 'edss_score',      jp: 'EDSSスコア',             type: 'decimal1', required: true },

  // ★新規追加（生活習慣）
  { key: 'hope_child', jp: '挙児希望', type: 'enum', enum: ['あり', 'なし'] },
  { key: 'smoking',    jp: '喫煙',     type: 'enum', enum: ['あり', 'なし'] },
  { key: 'drinking',   jp: '飲酒',     type: 'enum', enum: ['あり', 'なし'] },

  // ---- 症状・病歴 ----
  { key: 'complications',   jp: '合併症の有無',           type: 'string',   ui: { full: true } },
  { key: 'medical_history', jp: '既往歴の有無',           type: 'string',   ui: { full: true } },
  { key: 'family_history',  jp: '家族歴の有無',           type: 'string',   ui: { full: true } },

  // ★発症（detect）系：ここrename
  { key: 'first_detect_date', jp: '発症時期',   type: 'partialDate', ui: { full: true }, required: true },
  { key: 'first_detect_way',  jp: '発症様式',   type: 'enum', enum: ENUMS.onset_mode },

  // ★初回attack系（onset）
  { key: 'first_onset_date',     jp: '初回attack時期',    type: 'partialDate' },
  { key: 'first_onset_location', jp: '初回attack部位',    type: 'string' },
  { key: 'first_onset_symptom',  jp: '初回attack症状',    type: 'string' },

  // ★最終attack（rename）
  { key: 'last_onset_date', jp: '最終attackの時期', type: 'partialDate' },

  { key: 'recurrences_times', jp: '初発を含めない再発回数', type: 'enum', enum: ENUMS.recurrences_times },
  { key: 'pira_presence',      jp: '慢性進行の有無',      type: 'enum', enum: ENUMS.pira_presence },
  { key: 'pira_suspected_date',jp: '慢性進行が疑われた時期', type: 'partialDate' },
  { key: 'pira_symptoms',     jp: '慢性進行の症状',      type: 'string', ui: { full: true } },

  // ★新規追加：EDSS到達
  { key: 'last_edss3_date', jp: 'EDSS 3 到達時期', type: 'partialDate' },
  { key: 'last_edss6_date', jp: 'EDSS 6 到達時期', type: 'partialDate' },

  // ---- 検査 ----
  { key: 'aqp4_test',              jp: '抗AQP4抗体検査結果',       type: 'enum',  enum: ENUMS.aqp4_test },
  { key: 'mog_test',               jp: '抗MOG抗体検査結果',        type: 'enum',  enum: ENUMS.mog_test },
  { key: 'antibody_test',          jp: 'その他自己抗体が陽性のもの', type: 'string', ui: { full: true } },
  { key: 'cerebrospinal_fluid_test', jp: '髄液検査実施の有無',     type: 'enum',  enum: ENUMS.cerebrospinal_fluid_test },
  { key: 'fluid_test_date',        jp: '髄液検査実施の時期',       type: 'partialDate' },
  { key: 'ocb_result_type',        jp: '髄液検査結果（OCB）',      type: 'enum',  enum: ENUMS.ocb_result_type },
  { key: 'fluid_test_company',     jp: '髄液検査実施会社',         type: 'enum',  enum: ENUMS.fluid_test_company },
  { key: 'igg_result_score',       jp: '髄液検査結果（IgG index）', type: 'string' },

  // ---- 治療歴（Treatment）----
  ...Array.from({ length: 10 }, (_, i) => {
    const n = i + 1;
    return [
      {
        key: `treatment_start_${n}`,
        jp: `治療開始時期 ${n}`,
        type: 'partialDate',
      },
      {
        key: `treatment_drug_${n}`,
        jp: `治療薬 ${n}`,
        type: 'string',
      },
    ];
  }).flat(),
];

// 表示セクション（画面への出し分け）
export const SECTION_GROUPS = {
  personal: [
    'research_id',
    'consultation_id',
    'patient_pw',
    'date_of_birth',
    'gender_type',
    'ms_type',
    'edss_score',
    'hope_child',
    'smoking',
    'drinking',
  ],
  history: [
    'complications',
    'medical_history',
    'family_history',
    'first_detect_date',
    'first_detect_way',
    'first_onset_date',
    'first_onset_location',
    'first_onset_symptom',
    'last_onset_date',
    'recurrences_times',
    'pira_presence',
    'pira_suspected_date',
    'pira_symptoms',
    'last_edss3_date',
    'last_edss6_date',
  ],
  lab: [
    'aqp4_test',
    'mog_test',
    'antibody_test',
    'cerebrospinal_fluid_test',
    'fluid_test_date',
    'ocb_result_type',
    'fluid_test_company',
    'igg_result_score',
  ],
};

// 便利関数
export const toItems = (arr) => arr.map((v) => ({ id: v, text: v }));

export const buildOptionsFromFields = () => {
  const out = {};
  FIELDS.forEach((f) => {
    if (f.type === 'enum' && Array.isArray(f.enum)) out[f.key] = toItems(f.enum);
  });
  return out;
};

export const labelOf = (k) => FIELDS.find((f) => f.key === k)?.jp || k;
export const typeOf  = (k) => FIELDS.find((f) => f.key === k)?.type || 'string';
export const uiOf    = (k) => FIELDS.find((f) => f.key === k)?.ui || {};
export const isRequired = (k) => !!FIELDS.find((f) => f.key === k)?.required;
